.spw-card-excerpt {
  color: var(--spw-color-themes-grey-grey-600);
  font-family: 'Nunito Sans';
  font-size: 16px;
  line-height: 1.3;
  margin-top: 12px;
  &--has-clamp {
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;
  }
  @for $i from 1 through 10 {
    &--clamp-#{$i} {
      -webkit-line-clamp: $i;
      line-clamp: $i;
    }
  }
}
